// src/config.js
const isProd = window.location.hostname !== 'localhosxt';

export const WS_URL = isProd
    ? 'wss://sharpstack-api.4for4.com'
    : 'ws://localhost:8081';

export const TRACKING_API_URL = isProd
    ? 'https://sharpstack-api.4for4.com/api/tracked-bets'
    : 'http://localhost:8081/api/tracked-bets';

export const DEEPLINK_API_URL = isProd
    ? 'https://sharpstack-api.4for4.com/api/deeplink'
    : 'http://localhost:8081/api/deeplink';

export const ODDS_HISTORY_API_URL = isProd
    ? 'https://sharpstack-api.4for4.com/api/odds-history'
    : 'http://localhost:8081/api/odds-history';

export const RESULTS_EXPLORER_API_URL = isProd
    ? 'https://sharpstack-api.4for4.com/api/results-explorer'
    : 'http://localhost:8081/api/results-explorer';